import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class WorkCheckStatesRequest extends GenericRequest {

    constructor() {
        super(METHOD_POST, ApiEndpoints.MONTLY_WORK_CHECK_STATES);
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/ws/WorkCheckStatesRequest.js